export enum ESeaSegment {
  CHARTER = 'Charter',
  FCL = 'FCL',
  INLAND_HAULAGE = 'Inland Haulage',
  LCL = 'LCL',
  RORO = 'RoRo',
  SHORT_SEA = 'Short Sea',
}
